// Swiper is imported already
class productDetailSwiper extends HTMLElement {
  constructor() {
    super();

    this.swiperElement = this.querySelector('[data-product-detail-swiper]');

    this.swiperOptions = {
      direction: 'horizontal'
    }

    this.init();
  }

  init() {
    window.addEventListener('load', (event) => {
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

    });
    Fancybox.bind("[data-fancybox]", {
      animated: false,
      showClass: false
    });
  }
}

if(!customElements.get('product-detail-swiper')) {
  customElements.define('product-detail-swiper', productDetailSwiper);
}

class productInfo extends HTMLElement {
  constructor() {
    super();
    this.productForm = this.querySelector("product-form");
    this.productFormQuantity = this.productForm?.querySelector(
      'input[name="quantity"]'
    );
    this.quantityInput = this.querySelector("quantity-input");
    this.quantityInputElement = this.quantityInput?.querySelector(
      'input[name="quantity"]'
    );
    this.quantityInputElement?.addEventListener("change", () => {
      this.handleQuantityInput();
    });

    this.placeholderObserver();

  }

  placeholderObserver() {
    const placeholder = this.querySelector("[data-sticky-placeholder]");
    const placeholderHeight = placeholder.offsetHeight;
    const margin = placeholderHeight * -1 + 'px';
    const observerOptions = {
      threshold: 0,
      rootMargin: margin,
    };

    window.addEventListener("scroll", () => {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const placeholderBottom = placeholder.offsetTop + placeholder.offsetHeight;
      if (scrollTop >= placeholderBottom) {
        observer.unobserve(placeholder);
      } else {
        observer.observe(placeholder);
      }
    });

    const observer = new IntersectionObserver(([entry]) => {
      if (window.innerWidth < 768) {
        if (entry.isIntersecting) {
          this.querySelector("sticky-add-to-cart").classList.add("absolute");
        } else {
          this.querySelector("sticky-add-to-cart").classList.remove("absolute");
          observer.observe(placeholder);
        }
      }
    }, observerOptions);

    observer.observe(placeholder);
  }


  /**
   * handleQuantityInput
   * @description Set the quantity from the quantity input web component to the product form web component.
   */
  handleQuantityInput() {
    this.productFormQuantity.value = this.quantityInputElement.value;
  }
}

if(!customElements.get('product-info')) {
  customElements.define('product-info', productInfo);
}

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.formToggleButton = document.querySelector('[data-form-toggle]');
    this.backdropToggle = document.querySelector('[data-form-backdrop]');

    // Bind toggle event
    if (this.formToggleButton) {
      this.formToggleButton.addEventListener("click", function(e) {
        e.preventDefault();
        const productVariants = document.querySelector('[data-product-variants]');
        const backdrop = document.querySelector('[data-form-backdrop]');

        this.classList.toggle('visibility-hidden');
        productVariants.classList.toggle('visibility-hidden');
        backdrop.classList.toggle('visibility-hidden');
      });
    }
    if (this.backdropToggle) {
      this.backdropToggle.addEventListener("click", function(e) {
        e.preventDefault();
        const productVariants = document.querySelector('[data-product-variants]');
        const toggleButton = document.querySelector('[data-form-toggle]');

        this.classList.toggle('visibility-hidden');
        productVariants.classList.toggle('visibility-hidden');
        toggleButton.classList.toggle('visibility-hidden');
      });
    }
  }
}
/**
* handleQuantityInput
* @description Toggle the product form on the sticky add to cart (mobile)
*/

if(!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}